import type { GetNodeAncestorIds } from "../../state/index.ts";
import type { ResolveActiveNodes } from "../querying/index.ts";
import type { GetNodeAvailableActions } from "./getAvailableActions.ts";

interface CreateOptions {
  getAvailableActions: GetNodeAvailableActions;
  resolveActiveNodes: ResolveActiveNodes;
  getNodeAncestorIds?: GetNodeAncestorIds;
}

// TODO: copied from resolveAvailableValuesCreate which has a TODO on it.
export const resolveActiveNodeAvailableActionsCreate =
  ({ resolveActiveNodes, getAvailableActions, getNodeAncestorIds }: CreateOptions) =>
  (contextNodeId: number) => {
    const activeNodes = resolveActiveNodes(contextNodeId);
    const selfAndAncestorIds = getNodeAncestorIds ? [contextNodeId, ...getNodeAncestorIds(contextNodeId)] : undefined;
    return activeNodes.flatMap((node) =>
      getAvailableActions(node)
        .filter((action) => !action.filter || !selfAndAncestorIds || action.filter({ ancestorIds: selfAndAncestorIds }))
        .map(({ filter, ...action }) => ({ ...action, nodeId: node.id })),
    );
  };
